import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { Currency, Icon } from 'components';
import globalMsgs from 'messages';
import UserDevice from 'services/user-device';
import { usePlaceBet } from '../../hooks';
import messages from '../../messages';

import freeBetIcon from 'assets/svg/freebet.svg';
import './placeBet.scss';

interface Props {
    betslipBetId: string;
    totalStake: number;
    isFreebetActive?: boolean;
}

const PlaceBet: React.FC<Props> = ({
    betslipBetId,
    totalStake,
    isFreebetActive,
}) => {
    const { formatMessage } = useIntl();
    const {
        isAuthorized,
        isDisabled,
        isNeedDeposit,
        placeBetHandler,
        authHandler,
    } = usePlaceBet({
        betslipBetId,
        totalStake,
    });

    const styleName = cn('container', {
        'is-disabled': isDisabled && !isNeedDeposit,
        'is-freebet': isFreebetActive,
    });

    const placeBtnMessage = isNeedDeposit
        ? globalMsgs.deposit
        : isFreebetActive
        ? globalMsgs.freebet
        : globalMsgs.placeBet;

    const isMobile = UserDevice.getInstance()?.isDeviceMobile();

    return isAuthorized ? (
        <div
            styleName={styleName}
            className="__app-PlaceBet-container"
            onClick={placeBetHandler}
        >
            {isFreebetActive && <Icon glyph={freeBetIcon} styleName="icon" />}
            {formatMessage(placeBtnMessage)}
            {((isMobile && !isNeedDeposit) || isFreebetActive) && (
                <div styleName="stake">
                    <span styleName="amount">{totalStake.toFixed(2)}</span>
                    <Currency />
                </div>
            )}
        </div>
    ) : (
        <span
            styleName={styleName}
            onClick={authHandler}
            className="__app-PlaceBet-container"
        >
            {formatMessage(messages.signInBet)}
        </span>
    );
};

export default PlaceBet;
